import React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

// Only pass known props to Tooltip to avoid prop spreading warning
const LightTooltip = styled(
  ({ className, title, placement, arrow, open, onClick, children }) => (
    <Tooltip
      title={title}
      placement={placement}
      arrow={arrow}
      open={open}
      onClick={onClick}
      classes={{ popper: className }}
    >
      {children}
    </Tooltip>
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[2],
    fontSize: '16px',
    pointerEvents: 'auto !important',
    border: '1px solid #c7bdbd',
  },
  [`& .${tooltipClasses.arrow}`]: {
    '&::before': {
      boxShadow: theme.shadows[2],
      backgroundColor: theme.palette.common.white,
    },
  },
  [`&[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
    marginTop: '9.25px !important',
  },
}));

export default LightTooltip;
